<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <button-add :pathName="addAccountRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('004019001') !== -1"/>
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @seeExample="seeExample" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :hasOperation="false" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />

    <el-dialog title="优惠券详情" :visible.sync="dialogVisible" width="25%" :before-close="handleClose">
      <div>
        <div class="detail-item">
          <div>优惠券名称</div>
          <div>{{detailData.couponName}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券类型</div>
          <div>{{detailData.couponType}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券张数</div>
          <div>{{detailData.couponNum}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券售价(元)</div>
          <div>{{detailData.couponPrice}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../../components/Button/ButtonAdd";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import { api } from "../../../api/ParkingService";
import { errorHandler } from "../../../../utils/errorHandler";
import { nSuccess } from "../../../../utils/notice";
import { bus } from "../../../../utils/bus";
import ButtonCancel from "../../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "coupon-put-on-the-shelves",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "优惠券出售"
        }
      ],
      addAccountRouterName: "coupon-sell-add",
      addBtnValue: "优惠券出售",
      searchPlaceholder: "商户名称/购券人",
      searchKey: "",
      deleteTipInfo: "是否确认删除该信息？",
      tableHead: [
        {
          prop: "enterpriseName",
          label: "商户名称"
        },
        {
          prop: "personName",
          label: "购券人"
        },
        {
          prop: "couponName",
          label: "优惠券名称"
        },
        // {
        //   prop: "couponType",
        //   label: "优惠券类型"
        // },
        // {
        //   prop: "couponNum",
        //   label: "优惠券张数"
        // },
        // {
        //   prop: "couponPrice",
        //   label: "优惠券售价(元)"
        // },
        {
          prop: "coupon",
          label: "优惠券详情",
          example: true
        },
        {
          prop: "saleTime",
          label: "出售时间"
        },
        {
          prop: "saleNum",
          label: "出售份数"
        },
        {
          prop: "saleMoney",
          label: "出售总金额(元)"
        },
        {
          prop: "saleTotalNum",
          label: "出售总张数"
        },
        {
          prop: "payTypeText",
          label: "付款方式"
        },
        {
          prop: "payTime",
          label: "付款时间"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ["modify", "delete"],
      dialogVisible:false,
      detailData:[]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios
        .post(api.parkingCouponSaleGetPage, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          searchKey: this.searchKey
        })
        .then(res => {
          if (res.data.retCode === 1) {
            this.total = res.data.data.total;
            let data = res.data.data.list;
            data.map(v => {
              if (v.type === "金额") {
                v.denomination = `${v.denominationMoney}元`;
              } else {
                if (!v.denominationHour) {
                  v.denomination = `${v.denominationMinite}分钟`;
                } else {
                  v.denomination = `${v.denominationHour}小时${
                    v.denominationMinite
                  }分钟`;
                }
              }
              v.couponTimeValue = `${v.startTime}至${v.endTime}`;
              if (v.payType === "1") {
                v.payTypeText = "微信";
              } else if (v.payType === "2") {
                v.payTypeText = "支付宝";
              } else if (v.payType === "3") {
                v.payTypeText = "银行转账";
              } else if (v.payType === "4") {
                v.payTypeText = "现金";
              } else if (v.payType === "5") {
                v.payTypeText = "其他";
              }
            });
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    seeExample(data){
      this.detailData=data;
      console.log(data)
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    },
    // 修改
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/coupon_put_on_the_shelves_modify/${code}`
      });
    },
    // 删除
    deleteLine(code) {
      this.$axios
        .post(api.parkingCouponIssueDeleteByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.detail-item{
  display: flex;
  justify-content:space-between;
  align-items: center;
  margin: 10px 20px;
  font-size:14px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingCoupon/CouponSell/CouponSell.vue